function openURL(url: string) {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.dispatchEvent(new MouseEvent("click"));
  }
  
  export default openURL;